import React from 'react';
import { RadioContainer } from './styles';

const Radio = ({ label, name, value, checked, onChange }) => {
  return (
    <RadioContainer>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        className="hidden-radio"
      />
      <span className="radio-appearance"></span>
      <span className="radio-label">{label}</span>
    </RadioContainer>
  );
};

export default Radio;
